import { useQuery } from '@hooks/reactQuery';

import {
	getAlarmOranEnableStatuses,
	getAlarmOranGroups,
	getAlarmOranModuleNames,
	getAlarmOranSeverities,
} from '@api/oranAlarms';

import { optionsFormatted } from '@utils/formatter';

import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import {
	ALARM_GROUPS_ORAN_MANAGEMENT,
	ALARM_MODULE_NAMES_ORAN_MANAGEMENT,
	ALARM_SEVERITIES_ORAN_MANAGEMENT,
	ALARM_STATUSES_ORAN_MANAGEMENT,
} from '@constants/queryKeys';

export const useQueryOranCompliantFilters = (): IAlarmByVendorFilter => {
	const {
		data: groups,
		isInitialLoading: isLoadingGroups,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_GROUPS_ORAN_MANAGEMENT],
		queryFn: getAlarmOranGroups,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		...refetchOptions,
	});

	const {
		data: moduleNames,
		isInitialLoading: isLoadingModuleNames,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_MODULE_NAMES_ORAN_MANAGEMENT],
		queryFn: getAlarmOranModuleNames,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		...refetchOptions,
	});

	const {
		data: severities,
		isInitialLoading: isLoadingSeverities,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_SEVERITIES_ORAN_MANAGEMENT],
		queryFn: getAlarmOranSeverities,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		...refetchOptions,
	});

	const {
		data: statuses,
		isInitialLoading: isLoadingStatuses,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_STATUSES_ORAN_MANAGEMENT],
		queryFn: getAlarmOranEnableStatuses,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		...refetchOptions,
	});

	const oranCompliantFilters: IAlarmFilter[] = [
		{
			name: 'status',
			placeholder: 'Status',
			data: statuses || [],
		},
		{
			name: 'group',
			placeholder: 'Group',
			data: groups || [],
		},
		{
			name: 'severity',
			placeholder: 'Severity',
			data: severities || [],
		},
		{
			name: 'moduleName',
			placeholder: 'Module',
			data: moduleNames || [],
		},
	];

	return {
		filters: oranCompliantFilters,
		isLoading: isLoadingGroups ||
			isLoadingModuleNames ||
			isLoadingSeverities ||
			isLoadingStatuses,
	};
};
